import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { FormGroup, FormControl, ControlLabel, Button } from 'react-bootstrap';
import { login } from '../actions';
import { isLoggedIn } from '../utils';
import BlitzAPI from '../api/BlitzAPI';

class Login extends Component {
  constructor() {
    super();
    this.state = {
      email: '',
      password: '',
      loginActive: false,
      showError: false,
    };

    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    // Show Header Animation
    setTimeout(function() {
      this.setState({
        loginActive: true,
      });
    }.bind(this), 200);
  }

  handleUsernameChange(e) {
    const s = { email: e.target.value };
    this.setState(s);
  }

  handlePasswordChange(e) {
    this.setState({ password: e.target.value });
  }

  handleSubmit(e) {
    this.props.login({ user: this.state }).catch(
      (error) => {
        switch (error.response.status) {
          case 401:
            this.setState({ showError: true})
            break;
          default:
            alert(`SOMETHING WENT WRONG! Let Jonathan know and copy paste him this\n${JSON.stringify(error)}`)
            break;
        }
      },
    );
    e.preventDefault();
    return false;
  }

  render() {
    const { loggedIn, user } = this.props;
    const { email, loginActive, password, showError } = this.state;

    if (loggedIn) {
      BlitzAPI.setToken(user.profile.token);
      browserHistory.push('/entries/external');
    }
    return (
      <div className={`login-container ${loginActive ? 'login-active' : null}`}>
        <div className="login-background">
          <img className="fit-width" src="/assets/img/thumbnails/content-collage.jpg" role="presentation" />
        </div>
        <div className="login-overlay" />
        <div className="login">
          <div className="login-header">
            <div className="login-header-icon">
              <img className="fit-parent" src="/assets/img/icons/logo.png" role="presentation" />
            </div>
            <div className="login-header-title">
              <span className="login-header-blitz">Blitz</span>
              <span className="login-header-cms">CMS</span>
            </div>
          </div>
          <form onSubmit={this.handleSubmit}>
            <FormGroup>
              <ControlLabel>Email</ControlLabel>
              <FormControl
                type="text"
                value={email}
                placeholder="Email"
                onChange={this.handleUsernameChange}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>Password</ControlLabel>
              <FormControl
                type="password"
                value={password}
                placeholder="Password"
                onChange={this.handlePasswordChange}
              />
            </FormGroup>
            {showError && <div style={{ paddingBottom: '5px' }}>Incorrect Email or Password.<br /> If you've forgotten your password, <br />ping Jon for a reset!</div>}
            <Button type="submit" className="button-primary" value="submit">Login</Button>
          </form>
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  login: PropTypes.func,
  loggedIn: PropTypes.bool,
  user: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    loggedIn: isLoggedIn(state),
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    login: data => dispatch(login(data)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Login);



// WEBPACK FOOTER //
// ./src/cms/Login.js